/* TEKLED UK — Rooms Hub filter/search; safe for multiple section instances. */
(function () {
  function initialise(root) {
    if (!root || root.dataset.thrBound === '1') return;
    root.dataset.thrBound = '1';
    var search = root.querySelector('[data-space-search]');
    var tabs = Array.from(root.querySelectorAll('[data-space-group]'));
    var cards = Array.from(root.querySelectorAll('[data-space-card]'));
    var status = root.querySelector('[data-space-status]');
    var empty = root.querySelector('[data-space-empty]');
    var activeGroup = 'all';
    function render() {
      var query = search ? search.value.trim().toLocaleLowerCase() : '';
      var visible = 0;
      cards.forEach(function (card) {
        var groupMatch = activeGroup === 'all' || card.dataset.group === activeGroup;
        var queryMatch = !query || (card.dataset.search || '').toLocaleLowerCase().indexOf(query) !== -1;
        card.hidden = !(groupMatch && queryMatch);
        if (!card.hidden) visible += 1;
      });
      tabs.forEach(function (tab) {
        var selected = tab.dataset.spaceGroup === activeGroup;
        tab.setAttribute('aria-pressed', String(selected));
        tab.classList.toggle('is-active', selected);
      });
      if (status) status.textContent = visible + (visible === 1 ? ' space' : ' spaces');
      if (empty) empty.hidden = visible !== 0;
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activeGroup = tab.dataset.spaceGroup; render(); });
    });
    if (search) search.addEventListener('input', render);
    render();
    var jump = root.querySelector('.thr__jump');
    var detail = root.querySelector('.thr__expand');
    if (jump && detail) jump.addEventListener('click', function (e) {
      e.preventDefault(); detail.open = true;
      detail.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  }
  function initAll(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('.thr')) initialise(scope);
    scope.querySelectorAll && scope.querySelectorAll('.thr').forEach(initialise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (ev) { initAll(ev.target); });
})();
